/**
 * @generated SignedSource<<e142d7bc83080aebba3c56e881be24fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubSwitcherFragment_memberUser$data = {
  readonly memberUserProfiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly club: {
          readonly id: string;
          readonly logoImage: {
            readonly publicId: string;
          } | null | undefined;
          readonly name: string;
          readonly slug: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ClubSwitcherFragment_memberUser";
};
export type ClubSwitcherFragment_memberUser$key = {
  readonly " $data"?: ClubSwitcherFragment_memberUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubSwitcherFragment_memberUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubSwitcherFragment_memberUser",
  "selections": [
    {
      "alias": "memberUserProfiles",
      "args": [
        {
          "kind": "Literal",
          "name": "active",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "hidden",
          "value": false
        }
      ],
      "concreteType": "MemberProfileConnection",
      "kind": "LinkedField",
      "name": "memberProfiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberProfileEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberProfile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "logoImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "memberProfiles(active:true,hidden:false)"
    }
  ],
  "type": "MemberUser",
  "abstractKey": null
};

(node as any).hash = "244fc4c31e9612e6c81bcf02cbdbe380";

export default node;
